import * as React from 'react';
import classnames from 'classnames';
import { Select } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { getEyeLabel } from '../utils.js';
import { getSelectedQuantityValue } from './get-selected-quantity-value.js';

const CLQuantitySelector = ({ parentId , isDisabled , options , onChange , selectedQuantity , className ,  })=>{
    const intl = useIntl();
    const selectId = `${parentId}-quantity-select`;
    const eyeLabel = parentId !== 'both' ? getEyeLabel(intl, parentId) : undefined;
    const label = intl.getLabel('products.contactLenses.quantitySelect.label');
    const selectName = [
        'quantity-selector',
        eyeLabel
    ].filter(Boolean).join('-');
    const ariaLabel = [
        label,
        eyeLabel
    ].filter(Boolean).join(' ');
    const selectedValue = getSelectedQuantityValue(options, selectedQuantity);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("label", {
        className: `${className}__label`,
        htmlFor: selectId
    }, label), /*#__PURE__*/ React.createElement(Select, {
        id: selectId,
        name: selectName,
        "aria-label": ariaLabel,
        className: classnames('', className),
        options: options,
        initialState: selectedValue,
        disabled: isDisabled,
        onChange: onChange,
        "data-t": "select-quantity"
    }));
};

export { CLQuantitySelector };
//# sourceMappingURL=CLQuantitySelector.js.map
